var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.255 1.162a1 1 0 0 1 1.414 0l4.43 4.43a1 1 0 0 1-1.414 1.414l-2.723-2.723v9.399a1 1 0 1 1-2 0V4.283L6.24 7.006a1 1 0 1 1-1.414-1.414l4.43-4.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.9 11.475H2.525V22.13H17.4V11.475h-2.375a1 1 0 1 1 0-2h2.531a1.844 1.844 0 0 1 1.844 1.843v10.97a1.843 1.843 0 0 1-1.844 1.843H2.37a1.844 1.844 0 0 1-1.844-1.844V11.318a1.844 1.844 0 0 1 1.844-1.843h2.53a1 1 0 1 1 0 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.04d22db59ada9c550d71c4a9443b56f8.svg";
export { ForwardRef as ReactComponent };